import React, {Component} from 'react'
import {Button, Drawer, Form} from 'antd';
import Swal from "sweetalert2";
import {set_auth} from "../../../reducers/Auth";
import {connect} from "react-redux";

class Add extends Component {
    constructor() {
        super();
        this.state = {
            jabatan_nama: ''
        }
    }
    simpanJabatan = () => {
        let form = {
            name: this.state.jabatan_nama
        }

        this.props.request("jabatan/add", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    const filter_data = JSON.parse(localStorage.getItem('Presensi-Company-Data'))
                    if (filter_data && filter_data._jabatan) {
                        filter_data._jabatan.push({
                            jabatan_id      : response.data.jabatan_id,
                            perusahaan_id   : response.data.perusahaan_id,
                            jabatan_nama    : response.data.jabatan_nama,
                            updated_at      : response.data.updated_at,
                            created_at      : response.data.created_at
                        });
                        localStorage.setItem('Presensi-Company-Data', JSON.stringify(filter_data));
                    }
                    this.setState({jabatan_nama: ''})
                    this.props.set_auth(this.props.api_token, response.perusahaan);
                    this.props.changeState({
                        jabatan_nama: '',
                        add_visible: false,
                        data: [],
                        isLoading: true,
                    }, () => this.props.loadData())
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                }else if (response) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
            });
    }

    render() {
        return (
            <Drawer
                title="Tambah Jabatan"
                width={350}
                onClose={() => {
                    this.props.changeState({add_visible: false, divisi_name:''});
                }}
                visible={this.props.add_visible}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onClick={() => {
                            this.props.changeState({add_visible: false, jabatan_nama:''});
                        }}
                                style={{ marginRight: 8 }}>
                            Batal
                        </Button>
                        <Button onClick={this.simpanJabatan} type="primary">
                            Simpan
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical" hideRequiredMark>
                    <div className="form-group">
                        <label>Nama Jabatan</label>
                        <input name="jabatan_nama" className="form-control col-xl-12 col-md-12" placeholder="Nama Jabatan..."
                               type="text" required="" value={this.state.jabatan_nama}
                               onChange={(event) => {
                                   const target = event.target;
                                   const value  = target.value;
                                   const name   = target.name;
                                   this.setState({
                                       [name]: value
                                   });
                               }}/>
                    </div>
                </Form>
            </Drawer>

        )
    }
}

const mapStateToProps = state => ({
    auth: state.Auth.auth,
    api_token: state.Auth.api_token
})

const mapDispatchToProps = dispatch => ({
    set_auth: (api_token, data) => dispatch(set_auth(api_token, data))
})

export default connect(mapStateToProps, mapDispatchToProps)(Add)
